import {Injectable} from '@angular/core';
import {MenuItem, MxNavigationMenuElementsService} from 'mx-core';
import {MENU_ITEMS} from '../../consts/main-menu';
import {PrlPagesService} from './prl-pages.service';

const PAGE_NAME_MAP: Record<string, string> = {
    '/dashboard': 'Dashboard',
    '/statistic': 'Affiliate Statistics',
    '/profiles': 'Profiles Page',
    '/account': 'Account Page',
    '/finance': 'Finance Page',
    '/marketing-tools': 'Marketing Tools',
    '/info': 'Info Page'
};

@Injectable({
    providedIn: 'root'
})
export class NavigationMenuElementsService implements MxNavigationMenuElementsService {

    constructor(private pagesService: PrlPagesService) {}

    getMenuElements(): MenuItem[] {
        return MENU_ITEMS.filter(item => {
            const pageName = PAGE_NAME_MAP[item.link];
            return !pageName || this.pagesService.isPageEnabled(pageName);
        });
    }
}
